export const locale = {
  lang: 'zh2',
  data: {
    'AVANCES': {
      'GOSURVEY':'去调查',
      'GOPORTAL':'前往计数门户',
      'REGRESAR':'背部',
      'DESCARGAR':'下载文件',
      'PRIMEROS':'第一 1000',
      'SINCRONIZAR':'与计数门户同步',
      'AGREGAR': '加',
      'PRODUCTO':'产品',
      'FEC-LAN':'启动日期',
      'FEC-CIE':'结算日期',
      'NOFEC-LAN': "您尚未安排发布日期",
      'FEC-CIE-PROR':'关闭日期已延长',
      'CER': '仔细调查',
      'ABR': '公开调查',
      'PROR':'方案',
      'SURVEY':'调查: ',
      'FILE':'文件管理器: ',
      'WARNING-FECHA-GUARDAR':'您确定要添加过期的扩展程序吗 ',
      'SUCCESS-PRORROGA': '截止日期已更改为 ',
      'WARNING-CIERRE-ENCUESTA':'您确定要更改调查状态吗',
      'SUCCESS-CIERRE': '调查已正确更改',
      'PORCENTAJE':'回應預覽： ',
      'DES':'點擊顯示    ',
      'WARNING-BTN':'目前，由于您的调查尚未启动，因此我没有采取此操作',
      'PROCESARRESU': '处理结果',
      'ETIQUETAS':{
        'ETIQUETAS': '每页项目',
        'OF': '从',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          'MESSAGE1':'<span>确认删除用户答案',
          'MESSAGE2':'，在文本框中输入用户名x</span>',
          'MESSAGE3':'<span>确认删除用户答案，在文本框中输入用户名x ',
          'SALIR': '出口',
          'VALIDAR': '确认用户',
          'ERRORNOMBREEMPRESA': '输入的用户名，与您要删除的用户名不匹配',
          'MENSAJE': '¿你确定吗?\n\n您即将删除用户答案',
          'CANCELAR': '取消',
          'CONFIRMAR': '是的，删除',
          'SUCCES': '答案被删除',
          'CERRAR': '关<'
        },
        'MESSAGE':'¿确定要删除答案吗',
        'RESP_SI':'是',
        'RESP_NO':'没有',
        'ACEPTAR': '接受',
        'CANCELAR': '取消',
        'OK':'好',
        'SUCCESS-DELETE':'答案已成功删除',
        'ERROR-DELETE':'发生错误',
      },
      'PROCESAR': {
        'OK': '该过程已成功启动',
        'NOTOK': '该过程无法启动，首先您需要设置所需的结果'
      },
      'INS':{
        'INS1':' 的 ',
        'INS2':' 合作者 '
      },
      'INICIO':{
        'TITULO':'用户调查状态',
        'INSTRUCCIONES':'左侧是一个栏，上面有公司购买的产品。单击其中之一按年份显示客户，请选择其中一个以显示进行该产品调查的用户列表。',
      },
      'ENCUESTA':{
        'TTITULO': '用户进度调查',
        'PRODUCTS':'自有产品',
        'LABEL01':'名称',
        'LABEL02':'电子邮件',
        'LABEL03':'调查表',
        'LABEL04':'状态',
        'LABEL05':'邀請函',
        'LABEL06':'提醒',
        'LABEL07':'刪除',
        'LABEL08':'开始',
        'LABEL09':'结束',
        'LABEL10':'動作',
        'LABEL11':'電子郵件動作',
        'LABEL12':'存取键',
        'BUSCAR':'搜索',
        'CARGANDO':'载入中',
        'ACTIVA':'问卷调查未启用',
        //, 请稍候...。您拥有的用户总数为
        'PLACE':'输入您要寻找的合作者的名字',
        'ACTIONS':'隐藏的动作',
        'NOUSER':'找不到搜寻',
        'NA':'无法使用',
        'ERROR':'该产品还没有调查',
        'SUCCESS1':'邀請已發送',
        'SUCCESS2':'提醒已发送',
        'ERROR1':'发生错误',
      },
      'TITULOS':{
        'NAME':'协作者姓名',
        'ESTADOS':'调查状态',
        'FECHA1':'调查开始',
        'FECHA2':'结束调查',
        'ESTADOS_ENC':{
          'TITULO':'选择一个选项',
          'TODO':'显示所有',
          'ESTADO1':'用户尚未开始调查',
          'ESTADO2':'用户已登录',
          'ESTADO3':'进度调查',
          'ESTADO4':'用户已完成调查',
          'ESTADO5':'不接受',
          'ESTADO6':'我接受调查',
        }
      },
      'COLUMNAS':{
        'email':'电子邮件',
        'end_date':'最后日期',
        'id_status':'州',
        'name':'名称',
        'start_date':'开始日期'
      },
      'ACCIONES_EMAIL':{
        'ACCIONES':'電子郵件動作',
        'INFO':'下一步向您显示可行的操作给用户',
        'ACC1':'发送邀请',
        'ACC2':'发送提醒',
        'ACC3':'删除调查答案',
      },
      'NEWCOLAB': {
        'TITULO': '将新参与者添加到调查中',
        'INST_1': '完成每个必需的数据集以添加新参与者',
        'TITULO_MOD': '修改合作者数据',
        'INST_1_MOD': '您可以修改所选协作者的每个数据集',
        'INST_2': '标有（*）的字段为必填项',
        'WARNING1':'注意：此合作者的钥匙 ',
        'WARNING2':' 不能改变',
        'DATASET_1': '数据集1',
        'DATASET_2': '数据集2',
        'DATASET_3': '数据集3',
        'DATASET_4': '数据集4',
        'DATASET_5': '数据集5',
        'DATASET_6': '数据集6',
        'DATASET_7': '数据集7',
        'REQUIRED': '这是必填栏',
        'NEXT': '下一个',
        'BACK': '以前',
        'SAVE': '救',
        'ERR_OWNKEY': '输入的员工编号已存储在数据库中，请尝试其他',
        'ERR_BOSSKEY': '输入的老板号码未存储在数据库中，请尝试其他号码',
        'ERR_VAL_1': '在字段中输入的数据：',
        'ERR_VAL_2': '包含非法字符，或格式不正确',
        'GUARDANDO': '参与者信息正在存储中，请稍候',
        'GUARDANDO_GOFLOW': '信息正在存储中，请稍候。',
        'SAVE_OK': '新参与者的信息已正确存储',
        'MOD_OK': '参加者信息已成功修改',
        'FORMULARIO': '您尚未填写注册表，请检查是否已填写所有必填字段，然后重试',
        'ACCIONES': '用户动作',
        'VERACT': '用户动作',
        'LOADACT': '加载可用动作',
        'NOACT': '无法为此贡献者执行其他操作',
        'AVAACT': '可以为此协作者执行以下操作',
        'ACCIONLIST': {
          'modificar': '修改所选协作者的信息',
          'borrar': '删除所选的协作者'
        },
        'DELCOLAB': '您确定要从该产品中删除所选的协作者吗？注意：此操作无法撤消',
        'DEL_OK': '该协作者已成功从产品中删除',
        'ERR_EMAIL': '输入的电子邮件地址已存储在数据库中，请尝试其他电子邮件地址',
        'ERR_SAMEKEY': '输入的上司密钥和协作者密钥相同，这是不允许的，请尝试其他密钥',
        'RESET_COLAB_SURVE': '您确认重置调查访问权限吗？ ',
        'ACTU_OK': '它已正确更新',
      },
      'FORMULARIO_GO_FLOW':{
        'perspective': '看法',
        'statementID': '反应式 ID',
        'dimensionL1': '尺寸 L1',
        'dimensionL2': '尺寸 L2',
        'survey_Score_OverallTI': 'GlobalTI 分数调查',
        'company_Country': '国家公司',
        'cgo_Product_Name': '产品名称 cgo',
        'company_Name': '公司名',
        'ranking_Year': '排名年份',
        'survey_Respondents': '受访者',
        'survey_Score_Camaraderie': '友情分数调查',
        'survey_Score_Credibility': '信誉评分调查',
        'survey_Score_Imparciality': '公正性评分调查',
        'survey_Score_Pride': '骄傲分数调查',
        'survey_Score_Respect': '尊重分数调查',
        'survey_Score_Gestalt': '格式塔分数调查',
        'pdf_DateCreation': '证书创建日期',
        'WARNI_TI_DA':'输入的值不符合允许的格式 (100.00)',
        'WARNI_TI_DA_GRAL':'输入的数据不是指定的格式',
      },
      'FORMULARIO':{
        'fullName': '全名',
        'ownKey': '员工编号',
        'age': '出生年份',
        'surveyKey': '调查访问密钥',
        'email': '电子邮件',
        'bossName': '直接老板姓名',
        'bossKey': '直接老板号码',
        'country': '国家',
        'location': '位置',
        'geo_1': '地理等级1',
        'geo_2': '地理等级2',
        'geo_3': '地理级别3',
        'geo_4': '地理等级4',
        'geo_5': '地理等级5',
        'geo_6': '地理等级6',
        'geo_7': '地理等级7',
        'geo_8': '地理级别8',
        'geo_9': '地理等级9',
        'geo_10': '地理级别10',
        'geo_19': '地理级别19',
        'structure_1': '结构一级',
        'structure_2': '结构等级2',
        'structure_3': '结构等级3',
        'structure_4': '结构等级4',
        'structure_5': '结构等级5',
        'structure_6': '结构等级6',
        'structure_7': '结构等级7',
        'structure_8': '结构等级8',
        'structure_9': '结构层9',
        'structure_10': '结构层10',
        'area': '区',
        'bUnit': '业务部门',
        'enterDate': '进入公司的日期',
        'antiquity': '古代',
        'antiquityUS': '上古我们',
        'generation': '代',
        'generationUS': '一代我们',
        'ageUS': '年龄',
        'charge': '在公司中的职位或职能',
        'homologado': '充电或功能批准',
        'homologadoUS': '收费或功能批准了我们',
        'gender': '性别',
        'genderType': '性别类型',
        'typeofwork': '补偿类型',
        'workCondition': '工作条件',
        'academico': '学位',
        'contratacion': '合同类型',
        'situacionUS': '我们的工作情况',
        'personal': '员工类型',
        'jornada': '工作时间表类型',
        'rotacion': '确实旋转',
        'phone': '合作者的电话',
        'extension': '合作者的直接扩展',
        'cellphone': '合作者的手机',
        'native': '母语',
        'answer': '回答',
        'other_1': '其他1',
        'other_2': '其他2',
        'other_3': '其他3',
        'other_4': '其他4',
        'other_5': '其他5',
        'other_6': '其他6',
        'other_7': '其他7',
        'other_8': '其他8',
        'other_9': '其他9',
        'other_10': '其他10',
      },
      'SINCRONIZACION':{
        'SINCRONIZANDO':'与计数门户同步，请等待...',
        'SUCCESS':'同步正确完成'
      }
    },
  }
};
